import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Layout from 'components/Layout'
import ContentWrapper from 'components/Layout/ContentWrapper'

import Auth from 'components/Auth/AuthByRoles'
import PageAccessVerification from 'components/Auth/PageAccessVerification'
import FiscalInfoModal from './FiscalInfoModal'
import NetworkContractModal from './NetworkContractModal'
import CodeConductModal from './CodeConductModal'
import ParentSelectorModal from './ParentSelectorModal'
import { FiscalInfoActionCreators } from 'app/reducers/FiscalInfoRedux'
import { NetworkContractActionCreators } from 'app/reducers/NetworkContractRedux'
import { CodeConductActionCreators } from 'app/reducers/CodeConductRedux'
import { TentativeParentsActionCreators } from 'app/reducers/TentativeParentsRedux'
import { store } from 'services'
import config from 'config'
const COUNTRY = config('COUNTRY')
const NODE_ENV = config('NODE_ENV')
import availablePages from 'app/commonRoutes'

class LayoutAdmin extends Component {
  static propTypes = {
    children: PropTypes.any,
    title: PropTypes.any,
    hideModal: PropTypes.bool,
    hideLateralMenu: PropTypes.bool,
    subtitle: PropTypes.any,
    shouldShowFiscalModal: PropTypes.bool,
    shouldShowNetworkModal: PropTypes.bool,
    shouldShowCodeConductModal: PropTypes.bool,
    shouldShowParentSelectorModal: PropTypes.bool,
    checkFiscalPermissions: PropTypes.func.isRequired,
    checkAddNewChildPermission: PropTypes.func.isRequired,
    checkCodeConductPermission: PropTypes.func.isRequired,
    checkParentSelectorPermissions: PropTypes.func.isRequired,
    permissionCheckFeedback: PropTypes.object,
    isAuthenticated: PropTypes.bool,
    token: PropTypes.string,
    userSession: PropTypes.object,
  }

  static defaultProps = {
    hideModal: false,
    hideLateralMenu: false,
    pageRoles: [],
    pagePlans: [],
    shouldShowFiscalModal: false,
    shouldShowNetworkModal: false,
    shouldShowCodeConductModal: false,
    shouldShowParentSelectorModal: false,
  }

  componentDidMount() {
    if (this.props.isAuthenticated && this.props.token) {
      // Load profile info first (needed for ParentSelector permissions)
      this.props.getProfileInfo()
      this.props.checkFiscalPermissions()
      this.props.checkAddNewChildPermission()
      this.props.checkCodeConductPermission()
      
      // Check ParentSelector permissions after a delay to allow profile info to load
      setTimeout(() => {
        this.props.checkParentSelectorPermissions()
      }, 1500)
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isAuthenticated && this.props.isAuthenticated && this.props.token) {
      // Load profile info first (needed for ParentSelector permissions)
      this.props.getProfileInfo()
      this.props.checkFiscalPermissions()
      this.props.checkAddNewChildPermission()
      this.props.checkCodeConductPermission()
      
      // Check ParentSelector permissions after a delay to allow profile info to load
      setTimeout(() => {
        this.props.checkParentSelectorPermissions()
      }, 1500)
    }
  }

  handleFiscalModalClose = () => {
    this.props.closeFiscalModal()
  }

  handleNetworkModalClose = () => {
    this.props.closeNetworkModal()
  }

  handleCodeConductModalClose = () => {
    this.props.closeCodeConductModal()
  }

  handleParentSelectorModalClose = () => {
    this.props.closeParentSelectorModal()
  }

  render() {
    const {
      children,
      title,
      subtitle,
      hideModal,
      hideLateralMenu,
      pageRoles,
      pagePlans,
      notMatch,
      breadcrumbs,
      shouldShowFiscalModal,
      shouldShowNetworkModal,
      shouldShowCodeConductModal,
      shouldShowParentSelectorModal,
      permissionCheckFeedback,
      userSession,
      ...rest
    } = this.props

    return (
      <Layout {...rest}>
        <ContentWrapper
          title={title}
          subtitle={subtitle}
          hideModal={hideModal}
          hideLateralMenu={hideLateralMenu}
          hideSessionModal={this.props.hideSessionModal}
        >
          <Auth roles={pageRoles} plans={pagePlans} notMatch={notMatch}>
            <PageAccessVerification availablePages={availablePages} currentUrlData={rest.urlData}>
              {shouldShowFiscalModal && 
               !userSession.newDevice && 
               !userSession.excededDevices && 
               !userSession.shouldBeRevalidated && (
                <FiscalInfoModal
                  isOpen={shouldShowFiscalModal}
                  onClose={this.handleFiscalModalClose}
                />
              )}
              {shouldShowNetworkModal && 
               !shouldShowFiscalModal &&
               !userSession.newDevice && 
               !userSession.excededDevices && 
               !userSession.shouldBeRevalidated && (
                <NetworkContractModal
                  isOpen={shouldShowNetworkModal}
                  onClose={this.handleNetworkModalClose}
                />
              )}
              {shouldShowCodeConductModal && 
               !shouldShowFiscalModal &&
               !shouldShowNetworkModal &&
               !userSession.newDevice && 
               !userSession.excededDevices && 
               !userSession.shouldBeRevalidated && (
                <CodeConductModal
                  isOpen={shouldShowCodeConductModal}
                  onClose={this.handleCodeConductModalClose}
                />
              )}
              {shouldShowParentSelectorModal && 
               !shouldShowFiscalModal &&
               !shouldShowNetworkModal &&
               !shouldShowCodeConductModal &&
               !userSession.newDevice && 
               !userSession.excededDevices && 
               !userSession.shouldBeRevalidated && (
                <ParentSelectorModal
                  isOpen={shouldShowParentSelectorModal}
                  onClose={this.handleParentSelectorModalClose}
                />
              )}
              {breadcrumbs}
              {children}
            </PageAccessVerification>
          </Auth>
        </ContentWrapper>
      </Layout>
    )
  }
}

const mapStateToProps = (state) => ({
  shouldShowFiscalModal: state.fiscalInfo.shouldShowModal,
  shouldShowNetworkModal: state.networkContract.shouldShowModal,
  shouldShowCodeConductModal: state.codeConduct.shouldShowModal,
  shouldShowParentSelectorModal: state.tentativeParents.shouldShowParentSelectorModal,
  permissionCheckFeedback: state.fiscalInfo.permissionCheckFeedback,
  isAuthenticated: state.auth.isAuthenticated,
  token: state.auth.token,
  userSession: state.userSession,
})

const mapDispatchToProps = {
  checkFiscalPermissions: FiscalInfoActionCreators.checkFiscalPermissions,
  closeFiscalModal: FiscalInfoActionCreators.closeFiscalModal,
  closeNetworkModal: NetworkContractActionCreators.closeNetworkModal,
  checkAddNewChildPermission: NetworkContractActionCreators.checkAddNewChildPermission,
  closeCodeConductModal: CodeConductActionCreators.closeCodeConductModal,
  checkCodeConductPermission: CodeConductActionCreators.checkCodeConductPermission,
  checkParentSelectorPermissions: TentativeParentsActionCreators.checkParentSelectorPermissions,
  closeParentSelectorModal: TentativeParentsActionCreators.closeParentSelectorModal,
  getProfileInfo: store.getProfileInfo('user').action,
}

export default connect(mapStateToProps, mapDispatchToProps)(LayoutAdmin)
